export default "__VITE_ASSET__a0eaa3ef__"